module.exports = __webpack_public_path__ + "static/media/empty_state_geral.4c7af7d6.svg";